import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { runFlowTaskChangeSchedule } from '../actions/RunFlowTaskMenuActions';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';

export const RunFlowTaskChangeScheduleAction: IEntityAction<RunFlowTaskInfo, {}> = {
  name: EntityActionNames.TasksChangeSchedule,
  translateName: Messages.changeSchedule_action,
  isVisible: (targetItems: RunFlowTaskInfo[], state: AppState) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: RunFlowTaskInfo[]) => {
    return targetItems.length > 0;
  },
  createReduxAction: (targetItems: RunFlowTaskInfo[]) => runFlowTaskChangeSchedule(targetItems)
};
